export default "__VITE_ASSET__BsGVGKa9__"